module.exports = __webpack_public_path__ + "static/media/syncButton.135a8d8e.png";